var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAcknowledge = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 1000 1000",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M986 247.8 378.4 855.4c-5.4 5.4-14 5.4-19.4 0l-345-345c-5.3-5.3-5.3-14 0-19.3l83.8-83.8c5.4-5.3 14-5.3 19.4 0l251.5 251.5 514.1-514.1c5.4-5.3 14-5.3 19.4 0l83.8 83.8c5.3 5.3 5.3 13.9 0 19.3"
  })));
};
export default SvgAcknowledge;